import { Link } from "react-router-dom";
import type { Film } from "@/types/film";

interface FilmCardProps {
  film: Film;
  showSummary?: boolean;
}

export default function FilmCard({ film, showSummary = true }: FilmCardProps) {
  return (
    <article className="group flex flex-col">
      <Link
        to={`/detail/${film.id}`}
        className="relative block aspect-[2/3] w-full cursor-pointer overflow-hidden rounded-lg border border-background-200 bg-secondary-100"
        aria-label={`查看《${film.title}》详情`}
      >
        <img
          src={film.poster}
          alt={`${film.title} ${film.titleEn} 作品封面`}
          title={`${film.title} - 日韩伦理影视作品介绍`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
        />
        <span className="absolute left-2.5 top-2.5 rounded-md bg-background-50/95 px-2 py-1 font-label text-[11px] font-semibold text-primary-800">
          {film.score.toFixed(1)}
        </span>
        <span className="absolute bottom-2.5 left-2.5 rounded-md bg-primary-950/70 px-2 py-1 font-label text-[10px] tracking-wide text-background-50">
          {film.region} · {film.year}
        </span>
      </Link>

      <div className="mt-3 flex flex-1 flex-col">
        <div className="flex items-baseline justify-between gap-2">
          <Link
            to={`/detail/${film.id}`}
            className="cursor-pointer font-heading text-[15px] font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700"
          >
            {film.title}
          </Link>
          <span className="shrink-0 font-label text-[10px] uppercase tracking-wider text-secondary-500">
            {film.category}
          </span>
        </div>
        <p className="mt-1 font-label text-[11px] uppercase tracking-wide text-foreground-400">
          {film.titleEn}
        </p>
        <p className="mt-1.5 text-[12px] leading-relaxed text-foreground-600">
          {film.director} 执导 · {film.cast.slice(0, 2).join("、")}
        </p>
        {showSummary && (
          <p className="mt-2 line-clamp-2 text-[12px] leading-relaxed text-foreground-500">
            {film.summary}
          </p>
        )}
        <div className="mt-2.5 flex flex-wrap gap-1.5">
          {film.genres.map((genre) => (
            <span
              key={genre}
              className="rounded-full bg-secondary-100 px-2 py-0.5 text-[10px] text-secondary-900"
            >
              {genre}
            </span>
          ))}
        </div>
      </div>
    </article>
  );
}